import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { ProfileTier } from '@fcom/core-api/login/interfaces/login.interface';
import { AppState } from '@fcom/core';
import { profile } from '@fcom/core/selectors/login.selector';
import { finShare } from '@fcom/rx';
import { unsubscribe } from '@fcom/core/utils/unsubscribe';

@Directive({
  selector: '[finShowForProfileTiers]',
  standalone: false,
})
export class ShowForProfileTiersDirective implements OnDestroy {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private store$ = inject<Store<AppState>>(Store);

  private hasView = false;
  private subscriptions = new Subscription();

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('finShowForProfileTiers') set finShowForProfileTiers(tiers: ProfileTier[]) {
    if (!tiers || tiers.length === 0) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else {
      this.subscriptions.add(
        this.store$.pipe(profile(), finShare()).subscribe((memberProfile) => {
          if (tiers.includes(memberProfile.tier)) {
            if (!this.hasView) {
              this.viewContainer.createEmbeddedView(this.templateRef);
              this.hasView = true;
            }
          } else {
            this.viewContainer.clear();
            this.hasView = false;
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
